import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async createAvatar ({ state }) {
    const { data } = await directus.createItem('directus_files', {
      data: state.imageBlob,
      filename_disk: state.imageName,
      filename_download: state.imageName
    })
    return data.id
  },

  async update ({ state, commit, dispatch, rootState }) {
    try {
      const id = rootState.user.model.id
      let avatar
      if (state.imageBlob) avatar = await dispatch('createAvatar')

      const params = {
        first_name: state.firstName,
        last_name: state.lastName,
        email: state.email,
      }

      if (avatar) params.avatar = avatar

      const user = await directus.updateUser(id, params)
      commit('user/setAttr', {
        name: 'model',
        value: user.data
      }, { root: true })

      dispatch('user/set', null, { root: true })

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}

